import { render, staticRenderFns } from "./SubpageTownView.vue?vue&type=template&id=5412613f&scoped=true&"
import script from "./SubpageTownView.vue?vue&type=script&lang=js&"
export * from "./SubpageTownView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5412613f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5412613f')) {
      api.createRecord('5412613f', component.options)
    } else {
      api.reload('5412613f', component.options)
    }
    module.hot.accept("./SubpageTownView.vue?vue&type=template&id=5412613f&scoped=true&", function () {
      api.rerender('5412613f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/outagecenter/SubpageTownView.vue"
export default component.exports